import RemoveOS from './RemoveOS';

export default RemoveOS;